import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { COMPANY } from '../data/content.js'
import SocialRow from './SocialRow.jsx'

export default function Footer() {
  const { t } = useTranslation()

  return (
    <footer className="footer">
      <div className="container footer-inner">
        <div>
          <div className="footer-brand">
            <img src="/images/almus-logo.png" alt="Almus" className="brand-logo" />
            <img src="/images/science-fund.png" alt="Ғылым қоры / Фонд науки" className="fund-logo" />
          </div>
          <p>© {new Date().getFullYear()} {t('company')}. {t('footer.rights')}</p>
          <p>{COMPANY.address}</p>
          <p>{COMPANY.phone} · {COMPANY.email}</p>
        </div>
        <div>
          <SocialRow compact />
        </div>
      </div>
    </footer>
  )
}